import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatServiceService {
  toggle: boolean = false;


  constructor() { }


  openChatBot() {
    this.toggle = !this.toggle
    console.log('pressed toggle')
  }

}

